import { INavigationContext } from 'framework/context/INavigationContext';
import React from 'react';
import { InventoryItemDetailTabType } from '../detail/InventoryItemDetailTabType';

export const NavigationContext = React.createContext<INavigationContext<InventoryItemDetailTabType>>(undefined as any);
